import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export const checkDrawAdminRights = async (userId: string) => {
  if (!userId) return false;
  
  try {
    const adminDoc = await getDoc(doc(db, 'drawAdmins', userId));
    if (!adminDoc.exists()) return false;
    
    const data = adminDoc.data();
    return Boolean(data.canInitiateDraw);
  } catch (error) {
    console.error('Erreur lors de la vérification des droits admin:', error);
    return false;
  }
};

export const checkRequestOwnership = async (requestId: string, userId: string) => {
  try {
    const requestDoc = await getDoc(doc(db, '2dr_requests', requestId));
    return requestDoc.exists() && requestDoc.data()?.userId === userId;
  } catch (error) {
    console.error('Erreur lors de la vérification de la propriété:', error);
    return false;
  }
};

// Fonction pour vérifier si une demande peut être modifiée
export const canModifyRequest = async (requestId: string, userId: string) => {
  try {
    const requestDoc = await getDoc(doc(db, '2dr_requests', requestId));
    if (!requestDoc.exists()) return false;
    
    const data = requestDoc.data();
    return data.userId === userId && !data.hasDonations;
  } catch (error) {
    console.error('Erreur lors de la vérification des droits de modification:', error);
    return false;
  }
};

export const verifyRequestAccess = async (requestId: string, userId: string) => {
  if (!userId) return { canAccess: false, canModify: false, isOwner: false };
  
  const requestDoc = await getDoc(doc(db, '2dr_requests', requestId));
  if (!requestDoc.exists()) return { canAccess: false, canModify: false, isOwner: false };
  
  const data = requestDoc.data();
  const isOwner = data.userId === userId;
  
  return {
    canAccess: true,
    canModify: isOwner && !data.hasDonations,
    isOwner
  };
}; 